import { default as _91_46_46_46cms_93GxuGF9juS9Meta } from "/app/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93jK3Pyj8dSOMeta } from "/app/pages/blog/[...slug].vue?macro=true";
import { default as indexgWaMlevJ7RMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46slug_93LKgKAEZSF3Meta } from "/app/pages/catalog/[...slug].vue?macro=true";
import { default as temp_catalog_need_32_removenaTtEt8A4nMeta } from "/app/pages/catalog/temp_catalog_need _remove.vue?macro=true";
import { default as _91_46_46_46slug_93D5fO7mySkiMeta } from "/app/pages/product/[...slug].vue?macro=true";
import { default as index1YompLBf4tMeta } from "/app/pages/product/index.vue?macro=true";
import { default as _91_46_46_46slug_931ZUjCqWacxMeta } from "/app/pages/realty/[...slug].vue?macro=true";
import { default as indexBV1zPX3VR7Meta } from "/app/pages/sitemap/index.vue?macro=true";
import { default as indexHM7vyoHTUGMeta } from "/app/pages/wish/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93GxuGF9juS9Meta?.name ?? "cms",
    path: _91_46_46_46cms_93GxuGF9juS9Meta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93GxuGF9juS9Meta || {},
    alias: _91_46_46_46cms_93GxuGF9juS9Meta?.alias || [],
    redirect: _91_46_46_46cms_93GxuGF9juS9Meta?.redirect,
    component: () => import("/app/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93jK3Pyj8dSOMeta?.name ?? "blog-slug",
    path: _91_46_46_46slug_93jK3Pyj8dSOMeta?.path ?? "/blog/:slug(.*)*",
    meta: _91_46_46_46slug_93jK3Pyj8dSOMeta || {},
    alias: _91_46_46_46slug_93jK3Pyj8dSOMeta?.alias || [],
    redirect: _91_46_46_46slug_93jK3Pyj8dSOMeta?.redirect,
    component: () => import("/app/pages/blog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexgWaMlevJ7RMeta?.name ?? "blog",
    path: indexgWaMlevJ7RMeta?.path ?? "/blog",
    meta: indexgWaMlevJ7RMeta || {},
    alias: indexgWaMlevJ7RMeta?.alias || [],
    redirect: indexgWaMlevJ7RMeta?.redirect,
    component: () => import("/app/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93LKgKAEZSF3Meta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93LKgKAEZSF3Meta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93LKgKAEZSF3Meta || {},
    alias: _91_46_46_46slug_93LKgKAEZSF3Meta?.alias || [],
    redirect: _91_46_46_46slug_93LKgKAEZSF3Meta?.redirect,
    component: () => import("/app/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: temp_catalog_need_32_removenaTtEt8A4nMeta?.name ?? "catalog-temp_catalog_need _remove",
    path: temp_catalog_need_32_removenaTtEt8A4nMeta?.path ?? "/catalog/temp_catalog_need%20_remove",
    meta: temp_catalog_need_32_removenaTtEt8A4nMeta || {},
    alias: temp_catalog_need_32_removenaTtEt8A4nMeta?.alias || [],
    redirect: temp_catalog_need_32_removenaTtEt8A4nMeta?.redirect,
    component: () => import("/app/pages/catalog/temp_catalog_need _remove.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93D5fO7mySkiMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93D5fO7mySkiMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93D5fO7mySkiMeta || {},
    alias: _91_46_46_46slug_93D5fO7mySkiMeta?.alias || [],
    redirect: _91_46_46_46slug_93D5fO7mySkiMeta?.redirect,
    component: () => import("/app/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index1YompLBf4tMeta?.name ?? "product",
    path: index1YompLBf4tMeta?.path ?? "/product",
    meta: index1YompLBf4tMeta || {},
    alias: index1YompLBf4tMeta?.alias || [],
    redirect: index1YompLBf4tMeta?.redirect,
    component: () => import("/app/pages/product/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_931ZUjCqWacxMeta?.name ?? "realty-slug",
    path: _91_46_46_46slug_931ZUjCqWacxMeta?.path ?? "/realty/:slug(.*)*",
    meta: _91_46_46_46slug_931ZUjCqWacxMeta || {},
    alias: _91_46_46_46slug_931ZUjCqWacxMeta?.alias || [],
    redirect: _91_46_46_46slug_931ZUjCqWacxMeta?.redirect,
    component: () => import("/app/pages/realty/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexBV1zPX3VR7Meta?.name ?? "sitemap",
    path: indexBV1zPX3VR7Meta?.path ?? "/sitemap",
    meta: indexBV1zPX3VR7Meta || {},
    alias: indexBV1zPX3VR7Meta?.alias || [],
    redirect: indexBV1zPX3VR7Meta?.redirect,
    component: () => import("/app/pages/sitemap/index.vue").then(m => m.default || m)
  },
  {
    name: indexHM7vyoHTUGMeta?.name ?? "wish",
    path: indexHM7vyoHTUGMeta?.path ?? "/wish",
    meta: indexHM7vyoHTUGMeta || {},
    alias: indexHM7vyoHTUGMeta?.alias || [],
    redirect: indexHM7vyoHTUGMeta?.redirect,
    component: () => import("/app/pages/wish/index.vue").then(m => m.default || m)
  }
]